<template lang="pug">
  v-container(fluid fill-height class="ma-0 pa-0")
    v-img(height="100%" width="100%")
      l-map(
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
      style="height: 89vh",
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate",
        @click="mapclick",
        ref="myMap"
        :maxZoom="19"
        :minZoom="5"
      )
        l-tile-layer(:url="url" :attribution="attribution" :options="layerOptions" :tile-layer-class="tileLayerClass")
        l-marker-cluster(":options"="{disableClusteringAtZoom: 9}" ref="radarCluster")
          l-marker(v-for="m in radarMarkers" :key="m.ID" :lat-lng="m.LatLng" :icon="getIcon(m)" ref="markers")
            l-popup(style="padding:10px;")
              charger-popup(:car="car" :marker="m" :settings="settings" :canCenter="true" @centerRadar="centerRadar")
        l-marker-cluster(":options"="{disableClusteringAtZoom: 9}")
          l-marker(v-for="m in chargingMarkers" :key="m.id" :lat-lng="m.LatLng" :icon="getIcon(m)")
            l-popup
              charger-popup(:car="car" :marker="m" :settings="settings")  
        l-marker(v-if="homeLocation != null" :lat-lng="homeLocation" :zIndexOffset="100" :duration="1000" :icon="getHomeIcon()")   
        l-polyline(v-if="routeData" ":lat-lngs"="latLngs" :color="colourForTrip(trip != null ? trip.id : 1)")
        l-polygon(:lat-lngs="splat" fillColor="green" :smoothFactor="5" :stroke="false")
</template>

<script>
import MapSupport from "../mixins/MapSupport.js";
import L from "leaflet";
export default {
  mixins: [MapSupport],
  name: "Map",
  props: [
    "routeMarkers",
    "routeData",
    "chargers",
    "trip",
    "allChargers",
    "splat",
    "radarMarkers",
    "homeAddress",
    "car",
    "settings",
  ],
  computed: {
    homeLocation() {
      if (this.homeAddress.Address != null) {
        return L.latLng(
          this.homeAddress.Address.geometry.coordinates[1],
          this.homeAddress.Address.geometry.coordinates[0]
        );
      } else {
        return null;
      }
    },
    latLngs() {
      let latlngs = [];
      if (this.routeData && this.routeData.points) {
        for (let p of this.routeData.points) {
          latlngs.push([p[1], p[0]]);
        }
      }
      if (this.$refs.myMap && latlngs.length > 0) {
        this.$refs.myMap.mapObject.fitBounds(latlngs);
      } else {
        if (this.$refs.myMap) this.$refs.myMap.mapObject.setZoom(6);
      }
      return latlngs;
    },
    chargingMarkers() {
      let markers = [];

      if (this.routeData != null && this.routeData.charging_steps && !this.allChargers) {
        for (let ch of this.routeData.charging_steps) {
          let m = JSON.parse(JSON.stringify(ch));
          m.LatLng = { lat: m.location[1], lng: m.location[0] };

          let c = this.getChargerByID(m.id);
          if (c != null) {
            m.Current = c.Current;
            m.KwRated = c.KwRated;
            m.Charger = c;
          }
          markers.push(m);
        }
      }
      if (this.allChargers) {
        for (let i = 0; i < this.chargers.length; i++) {
          let c = this.chargers[i];
          let m = JSON.parse(JSON.stringify(c));
          m.LatLng = { lat: m.Latitude, lng: m.Longitude };
          m.Charger = c;
          markers.push(m);
        }
      }

      return markers;
    },
  },
  methods: {
    centerRadar(m) {
      this.$emit("centerRadar", m);
    },
    centerMap(latlng) {
      this.$refs.myMap.mapObject.panTo(new L.latLng(latlng.lat, latlng.lng));
    },
  },
};
</script>
<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
